import { navigate, RouteComponentProps, useLocation } from '@reach/router';
import firebase from 'firebase/app';
import 'firebase/analytics';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Preloader from '../../../layouts/preloaders/Preloader';
import { User } from '../../../models/User';
import { setUser } from '../../../redux/AuthSlice';

interface ILoginRouteProps {
    title?: string;
    path?: RouteComponentProps;
    component: React.ComponentType;
}

const LoginRoute: React.FunctionComponent<ILoginRouteProps> = ({ component: Component, ...rest }) => {
    const dispatch = useDispatch();
    const [isReady, setIsReady] = useState(false);
    const location = useLocation();

    const updateUser = (user: User) => {
        const payload: User = {
            displayName: user.displayName,
            email: user.email,
            phoneNumber: user.phoneNumber,
            photoURL: user.photoURL,
            providerId: user.providerId,
            uid: user.uid,
        };
        dispatch(setUser(payload));
    };

    useEffect(() => {
        let page_title = 'Memo App (Beta)';

        if (rest.title) {
            page_title = 'Login | Memo App (Beta)';
            document.title = page_title;
            firebase.analytics().setCurrentScreen(location.pathname);
            firebase.analytics().logEvent('page_view', { page_path: location.pathname, page_title: rest.title });
        } else {
            document.title = page_title;
        }

        firebase.analytics().setCurrentScreen(location.pathname);
        firebase.analytics().logEvent('page_view', { page_path: location.pathname });
        firebase.auth().onAuthStateChanged((user) => {
            if (!user) {
                setIsReady(true);
            } else {
                updateUser(user);
                navigate('/dashboard');
            }
        });
    }, []);

    if (isReady) {
        return <Component {...rest} />;
    }
    return <Preloader />;
};

LoginRoute.propTypes = {
    component: PropTypes.any,
};

export default LoginRoute;
